import { Box, Stack, Typography } from '@mui/material'

interface LegendItem {
  color: string
  label: string
  value: string | number
}

const PieLegendList = ({ items }: { items: LegendItem[] }) => (
  <Stack spacing={0.75} sx={{ width: '100%' }}>
    {items.map((item) => (
      <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: item.color, flexShrink: 0 }} />
          <Typography variant='caption' sx={{ color: '#5A6472', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {item.label}
          </Typography>
        </Box>
        <Typography variant='caption' sx={{ fontWeight: 700, color: '#002C5F', flexShrink: 0 }}>
          {item.value}
        </Typography>
      </Box>
    ))}
  </Stack>
)

export default PieLegendList
